import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import { PRODUCT_NAME } from "@src/shared/brand";
import { HeaderText } from "@src/shared/components/general/HeaderText";
import { Logo } from "@src/shared/components/general/Logo";
import { Text } from "@src/shared/components/general/Text";
import {
  HorizontalFlexbox,
  VerticalFlexbox,
} from "@src/shared/components/layout/Flexbox";
import { Button } from "@src/shared/components/ui/button";

export const HomePage = () => {
  return (
    <VerticalFlexbox
      alignItems="center"
      justifyContent="center"
      className="min-h-screen w-full bg-gradient-to-b from-background to-muted/50 px-6 py-12"
    >
      <VerticalFlexbox
        alignItems="center"
        gap="md"
        className="max-w-xl text-center"
      >
        <HorizontalFlexbox alignItems="center" gap="sm">
          <Logo className="size-10" />
          <Text as="span" sizing="xl" fontWeight={600}>
            {PRODUCT_NAME.singular}
          </Text>
        </HorizontalFlexbox>
        <HeaderText
          tag="h1"
          className="text-4xl leading-tight sm-stitch:text-5xl"
        >
          The clinical copilot where every thread meets.
        </HeaderText>
        <Text appearance="subdued" className="max-w-md">
          Prep, document, code, and close — {PRODUCT_NAME.singular} helps your
          team deliver value-based care without the busywork.
        </Text>
        <Button
          asChild
          size="lg"
          className="bg-accent text-accent-foreground hover:bg-accent/90"
        >
          <Link to="/dashboard">
            Open dashboard
            <ArrowRight className="ml-1 size-4" />
          </Link>
        </Button>
      </VerticalFlexbox>
    </VerticalFlexbox>
  );
};
